'use client';

import Grid from '@mui/material/Grid';

import * as Sentry from 'utils/errorTracking';
import RenderError from 'components/ErrorComponents/RenderError';
import { useEffect } from 'react';

// Utils
import { getKeywords } from 'utils/seo';
import { DEFAULT_OG_IMAGE, DEFAULT_TWITTER_IMAGE } from 'utils/constants/metadata';

export async function generateMetadata() {
  const description = 'Something went wrong. Please try again later.';

  const keywords = getKeywords(description);

  return {
    title: 'Something went wrong',
    description,
    keywords,
    author: 'StartEngine',
    openGraph: {
      locale: 'en_US',
      type: 'article',
      title: 'Something went wrong',
      description,
      keywords,
      author: 'StartEngine',
      url: 'https://www.startengine.com/error',
      site_name: 'StartEngine',
      images: [{ ...DEFAULT_OG_IMAGE, alt: 'Something went wrong | StartEngine' }],
    },
    twitter: {
      title: 'Invest in Startups Online',
      description,
      keywords,
      author: 'StartEngine',
      cardType: 'summary_large_image',
      site: '@StartEngineLA',
      image: DEFAULT_TWITTER_IMAGE,
    },
    alternates: {
      canonical: 'https://www.startengine.com/error',
    },
  };
}

export default function Error({ reset, error }) {
  useEffect(() => {
    // Check if this is a browser extension ethereum property descriptor error
    const isEthereumPropertyError = error?.message?.includes('Invalid property descriptor') ||
                                   error?.message?.includes('Cannot both specify accessors and a value or writable attribute') ||
                                   (error?.message?.includes('Cannot redefine property') && error?.message?.includes('ethereum')) ||
                                   (error?.message?.includes('Cannot set property ethereum') && error?.message?.includes('which has only a getter'));
    
    // Check if error comes from a browser extension
    const isExtensionError = error?.stack?.includes('chrome-extension://') ||
                            error?.stack?.includes('moz-extension://') ||
                            error?.stack?.includes('safari-extension://') ||
                            error?.stack?.includes('ms-browser-extension://');
    
    // Only send to Sentry if it's not a browser extension related error
    if (!isEthereumPropertyError && !isExtensionError) {
      Sentry.captureException(error);
    } else {
      console.warn('[StartEngine] Suppressed browser extension error in error page:', error?.message);
    }
  }, [error]);

  return (
    <div>
      <Grid
        sx={{
          my: {
            xs: '200px',
          },
        }}
      >
        <RenderError
          handleFunction={() => {
            reset();
          }}
          error={error}
        />
      </Grid>
    </div>
  );
}
